/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CompanyDTO,
  CountCompaniesParams,
  GetAllCompaniesParams
} from '../model';

import { customInstance } from '../mutator/custom-instance';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getAllCompanies = (
    params: GetAllCompaniesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CompanyDTO[]>(
      {url: `/api/companies`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetAllCompaniesInfiniteQueryKey = (params?: GetAllCompaniesParams,) => {
    return [
    'infinite', `/api/companies`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetAllCompaniesQueryKey = (params?: GetAllCompaniesParams,) => {
    return [
    `/api/companies`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAllCompaniesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getAllCompanies>>>, TError = unknown>(params: GetAllCompaniesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllCompanies>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllCompaniesInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllCompanies>>> = ({ signal }) => getAllCompanies(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllCompanies>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllCompaniesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getAllCompanies>>>
export type GetAllCompaniesInfiniteQueryError = unknown


export function useGetAllCompaniesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllCompanies>>>, TError = unknown>(
 params: GetAllCompaniesParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllCompanies>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllCompanies>>,
          TError,
          Awaited<ReturnType<typeof getAllCompanies>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllCompaniesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllCompanies>>>, TError = unknown>(
 params: GetAllCompaniesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllCompanies>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllCompanies>>,
          TError,
          Awaited<ReturnType<typeof getAllCompanies>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllCompaniesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllCompanies>>>, TError = unknown>(
 params: GetAllCompaniesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllCompanies>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAllCompaniesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllCompanies>>>, TError = unknown>(
 params: GetAllCompaniesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllCompanies>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllCompaniesInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetAllCompaniesQueryOptions = <TData = Awaited<ReturnType<typeof getAllCompanies>>, TError = unknown>(params: GetAllCompaniesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllCompanies>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllCompaniesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllCompanies>>> = ({ signal }) => getAllCompanies(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllCompanies>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllCompaniesQueryResult = NonNullable<Awaited<ReturnType<typeof getAllCompanies>>>
export type GetAllCompaniesQueryError = unknown


export function useGetAllCompanies<TData = Awaited<ReturnType<typeof getAllCompanies>>, TError = unknown>(
 params: GetAllCompaniesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllCompanies>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllCompanies>>,
          TError,
          Awaited<ReturnType<typeof getAllCompanies>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllCompanies<TData = Awaited<ReturnType<typeof getAllCompanies>>, TError = unknown>(
 params: GetAllCompaniesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllCompanies>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllCompanies>>,
          TError,
          Awaited<ReturnType<typeof getAllCompanies>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllCompanies<TData = Awaited<ReturnType<typeof getAllCompanies>>, TError = unknown>(
 params: GetAllCompaniesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllCompanies>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAllCompanies<TData = Awaited<ReturnType<typeof getAllCompanies>>, TError = unknown>(
 params: GetAllCompaniesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllCompanies>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllCompaniesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const updateCompany = (
    companyDTO: CompanyDTO,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<CompanyDTO>(
      {url: `/api/companies`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: companyDTO
    },
      options);
    }
  


export const getUpdateCompanyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCompany>>, TError,{data: CompanyDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCompany>>, TError,{data: CompanyDTO}, TContext> => {

const mutationKey = ['updateCompany'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCompany>>, {data: CompanyDTO}> = (props) => {
          const {data} = props ?? {};

          return  updateCompany(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof updateCompany>>>
    export type UpdateCompanyMutationBody = CompanyDTO
    export type UpdateCompanyMutationError = unknown

    export const useUpdateCompany = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCompany>>, TError,{data: CompanyDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateCompany>>,
        TError,
        {data: CompanyDTO},
        TContext
      > => {

      const mutationOptions = getUpdateCompanyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const createCompany = (
    companyDTO: CompanyDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CompanyDTO>(
      {url: `/api/companies`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: companyDTO, signal
    },
      options);
    }
  


export const getCreateCompanyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCompany>>, TError,{data: CompanyDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createCompany>>, TError,{data: CompanyDTO}, TContext> => {

const mutationKey = ['createCompany'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCompany>>, {data: CompanyDTO}> = (props) => {
          const {data} = props ?? {};

          return  createCompany(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof createCompany>>>
    export type CreateCompanyMutationBody = CompanyDTO
    export type CreateCompanyMutationError = unknown

    export const useCreateCompany = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCompany>>, TError,{data: CompanyDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createCompany>>,
        TError,
        {data: CompanyDTO},
        TContext
      > => {

      const mutationOptions = getCreateCompanyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getCompany1 = (
    glNo: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CompanyDTO>(
      {url: `/api/companies/${glNo}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetCompany1InfiniteQueryKey = (glNo?: string,) => {
    return [
    'infinite', `/api/companies/${glNo}`
    ] as const;
    }

export const getGetCompany1QueryKey = (glNo?: string,) => {
    return [
    `/api/companies/${glNo}`
    ] as const;
    }

    
export const getGetCompany1InfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getCompany1>>>, TError = unknown>(glNo: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompany1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompany1InfiniteQueryKey(glNo);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompany1>>> = ({ signal }) => getCompany1(glNo, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(glNo), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompany1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCompany1InfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getCompany1>>>
export type GetCompany1InfiniteQueryError = unknown


export function useGetCompany1Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getCompany1>>>, TError = unknown>(
 glNo: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompany1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompany1>>,
          TError,
          Awaited<ReturnType<typeof getCompany1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCompany1Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getCompany1>>>, TError = unknown>(
 glNo: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompany1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompany1>>,
          TError,
          Awaited<ReturnType<typeof getCompany1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCompany1Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getCompany1>>>, TError = unknown>(
 glNo: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompany1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetCompany1Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getCompany1>>>, TError = unknown>(
 glNo: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompany1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCompany1InfiniteQueryOptions(glNo,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetCompany1QueryOptions = <TData = Awaited<ReturnType<typeof getCompany1>>, TError = unknown>(glNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompany1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompany1QueryKey(glNo);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompany1>>> = ({ signal }) => getCompany1(glNo, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(glNo), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompany1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCompany1QueryResult = NonNullable<Awaited<ReturnType<typeof getCompany1>>>
export type GetCompany1QueryError = unknown


export function useGetCompany1<TData = Awaited<ReturnType<typeof getCompany1>>, TError = unknown>(
 glNo: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompany1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompany1>>,
          TError,
          Awaited<ReturnType<typeof getCompany1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCompany1<TData = Awaited<ReturnType<typeof getCompany1>>, TError = unknown>(
 glNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompany1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompany1>>,
          TError,
          Awaited<ReturnType<typeof getCompany1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCompany1<TData = Awaited<ReturnType<typeof getCompany1>>, TError = unknown>(
 glNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompany1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetCompany1<TData = Awaited<ReturnType<typeof getCompany1>>, TError = unknown>(
 glNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompany1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCompany1QueryOptions(glNo,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getLoginCompany = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CompanyDTO>(
      {url: `/api/companies/login`, method: 'GET', signal
    },
      options);
    }
  



export const getGetLoginCompanyInfiniteQueryKey = () => {
    return [
    'infinite', `/api/companies/login`
    ] as const;
    }

export const getGetLoginCompanyQueryKey = () => {
    return [
    `/api/companies/login`
    ] as const;
    }

    
export const getGetLoginCompanyInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getLoginCompany>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoginCompany>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLoginCompanyInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoginCompany>>> = ({ signal }) => getLoginCompany(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoginCompany>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLoginCompanyInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getLoginCompany>>>
export type GetLoginCompanyInfiniteQueryError = unknown


export function useGetLoginCompanyInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLoginCompany>>>, TError = unknown>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoginCompany>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoginCompany>>,
          TError,
          Awaited<ReturnType<typeof getLoginCompany>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoginCompanyInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLoginCompany>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoginCompany>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoginCompany>>,
          TError,
          Awaited<ReturnType<typeof getLoginCompany>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoginCompanyInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLoginCompany>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoginCompany>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetLoginCompanyInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLoginCompany>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoginCompany>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLoginCompanyInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetLoginCompanyQueryOptions = <TData = Awaited<ReturnType<typeof getLoginCompany>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoginCompany>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLoginCompanyQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoginCompany>>> = ({ signal }) => getLoginCompany(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLoginCompany>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLoginCompanyQueryResult = NonNullable<Awaited<ReturnType<typeof getLoginCompany>>>
export type GetLoginCompanyQueryError = unknown


export function useGetLoginCompany<TData = Awaited<ReturnType<typeof getLoginCompany>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoginCompany>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoginCompany>>,
          TError,
          Awaited<ReturnType<typeof getLoginCompany>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoginCompany<TData = Awaited<ReturnType<typeof getLoginCompany>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoginCompany>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoginCompany>>,
          TError,
          Awaited<ReturnType<typeof getLoginCompany>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoginCompany<TData = Awaited<ReturnType<typeof getLoginCompany>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoginCompany>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetLoginCompany<TData = Awaited<ReturnType<typeof getLoginCompany>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoginCompany>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLoginCompanyQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const countCompanies = (
    params: CountCompaniesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<number>(
      {url: `/api/companies/count`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getCountCompaniesInfiniteQueryKey = (params?: CountCompaniesParams,) => {
    return [
    'infinite', `/api/companies/count`, ...(params ? [params]: [])
    ] as const;
    }

export const getCountCompaniesQueryKey = (params?: CountCompaniesParams,) => {
    return [
    `/api/companies/count`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getCountCompaniesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof countCompanies>>>, TError = unknown>(params: CountCompaniesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof countCompanies>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCountCompaniesInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof countCompanies>>> = ({ signal }) => countCompanies(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof countCompanies>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type CountCompaniesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof countCompanies>>>
export type CountCompaniesInfiniteQueryError = unknown


export function useCountCompaniesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof countCompanies>>>, TError = unknown>(
 params: CountCompaniesParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof countCompanies>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof countCompanies>>,
          TError,
          Awaited<ReturnType<typeof countCompanies>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useCountCompaniesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof countCompanies>>>, TError = unknown>(
 params: CountCompaniesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof countCompanies>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof countCompanies>>,
          TError,
          Awaited<ReturnType<typeof countCompanies>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useCountCompaniesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof countCompanies>>>, TError = unknown>(
 params: CountCompaniesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof countCompanies>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useCountCompaniesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof countCompanies>>>, TError = unknown>(
 params: CountCompaniesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof countCompanies>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getCountCompaniesInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getCountCompaniesQueryOptions = <TData = Awaited<ReturnType<typeof countCompanies>>, TError = unknown>(params: CountCompaniesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countCompanies>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCountCompaniesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof countCompanies>>> = ({ signal }) => countCompanies(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof countCompanies>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type CountCompaniesQueryResult = NonNullable<Awaited<ReturnType<typeof countCompanies>>>
export type CountCompaniesQueryError = unknown


export function useCountCompanies<TData = Awaited<ReturnType<typeof countCompanies>>, TError = unknown>(
 params: CountCompaniesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof countCompanies>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof countCompanies>>,
          TError,
          Awaited<ReturnType<typeof countCompanies>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useCountCompanies<TData = Awaited<ReturnType<typeof countCompanies>>, TError = unknown>(
 params: CountCompaniesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countCompanies>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof countCompanies>>,
          TError,
          Awaited<ReturnType<typeof countCompanies>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useCountCompanies<TData = Awaited<ReturnType<typeof countCompanies>>, TError = unknown>(
 params: CountCompaniesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countCompanies>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useCountCompanies<TData = Awaited<ReturnType<typeof countCompanies>>, TError = unknown>(
 params: CountCompaniesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countCompanies>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getCountCompaniesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getAllBranches = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CompanyDTO[]>(
      {url: `/api/companies/all`, method: 'GET', signal
    },
      options);
    }
  



export const getGetAllBranchesInfiniteQueryKey = () => {
    return [
    'infinite', `/api/companies/all`
    ] as const;
    }

export const getGetAllBranchesQueryKey = () => {
    return [
    `/api/companies/all`
    ] as const;
    }

    
export const getGetAllBranchesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getAllBranches>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllBranches>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllBranchesInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllBranches>>> = ({ signal }) => getAllBranches(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllBranches>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllBranchesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getAllBranches>>>
export type GetAllBranchesInfiniteQueryError = unknown


export function useGetAllBranchesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllBranches>>>, TError = unknown>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllBranches>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllBranches>>,
          TError,
          Awaited<ReturnType<typeof getAllBranches>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllBranchesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllBranches>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllBranches>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllBranches>>,
          TError,
          Awaited<ReturnType<typeof getAllBranches>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllBranchesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllBranches>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllBranches>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAllBranchesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllBranches>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllBranches>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllBranchesInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetAllBranchesQueryOptions = <TData = Awaited<ReturnType<typeof getAllBranches>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllBranches>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllBranchesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllBranches>>> = ({ signal }) => getAllBranches(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllBranches>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllBranchesQueryResult = NonNullable<Awaited<ReturnType<typeof getAllBranches>>>
export type GetAllBranchesQueryError = unknown


export function useGetAllBranches<TData = Awaited<ReturnType<typeof getAllBranches>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllBranches>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllBranches>>,
          TError,
          Awaited<ReturnType<typeof getAllBranches>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllBranches<TData = Awaited<ReturnType<typeof getAllBranches>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllBranches>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllBranches>>,
          TError,
          Awaited<ReturnType<typeof getAllBranches>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllBranches<TData = Awaited<ReturnType<typeof getAllBranches>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllBranches>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAllBranches<TData = Awaited<ReturnType<typeof getAllBranches>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllBranches>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllBranchesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




